import type { AdminStore } from '@/client/types/stores';
import {
  STORE_STATUS_LABEL,
  STORE_STATUS_TONE,
  deriveStoreStatus,
} from '@/client/types/stores/status';
import { cn } from '@/lib/utils';

export const StoreStatusBadge: React.FC<{ store: AdminStore }> = ({ store }) => {
  const status = deriveStoreStatus(store);
  return (
    <span
      className={cn(
        'inline-flex rounded-full px-2 py-1 text-xs font-semibold leading-5',
        STORE_STATUS_TONE[status],
      )}
    >
      {STORE_STATUS_LABEL[status]}
    </span>
  );
};
